enum EnumReferralTrigger {
  InvitedGotPremium = 0,
  InvitedPurchasedPremium = 1,
  NInvitedPurchasedPremium = 2,
  NInvitedPurchasedPremiumWithinDays = 3,
  StreakDays = 4,
}

export default EnumReferralTrigger;
